<template>
  <body class="content-body">
    <SustainabilityCommitment />
    <Mission />
    <OurMission />
    <Difference />
    <HighlightSection
      id="environmentalImpact"
      labelText="Environmental Impact"
      headingText="Industry-Wide Impact"
      :headingWidthProp="679"
      textContent="Wecobi’s platform is designed to create a meaningful impact across multiple industries, each with its unique challenges and opportunities:"
      :textMaxWidth="679"
      fontSizeProp="large"
    />
    <ImpactSection />
    <Focus />
    <Growth />
    <HighlightSection
      id="decoupledGrowth"
      labelText="Decoupled Growth"
      headingText="How wecobi Faciliates Decoupled Growth"
      :headingWidthProp="652"
      fontSizeProp="small"
    />
    <StepsSection />
    <HighlightSection
      id="winEnergy"
      labelText="Win-Win-Win Strategy"
      headingText="Wecobi's Win-Win-Win Strategy"
      :headingWidthProp="652"
      textContent="At Wecobi, we've developed a unique approach to commerce that benefits everyone involved—the brands, the consumers, and the environment. Our Win-Win-Win Strategy is designed to ensure that each stakeholder gains value while contributing to a more sustainable future."
      :textMaxWidth="816"
      fontSizeProp="small"
    />
    <WinForAll />
    <Strategy />
    <!-- <WhyWecobi /> -->
    <StayAhead />
    <JoinUs />
  </body>
</template>

<script>
import SustainabilityCommitment from "../Sustainability/Content/SustainabilityCommitment.vue";
import Mission from "./Content/Mission.vue";
import OurMission from "./Content/OurMission.vue";
import Difference from "./Content/Difference.vue";
import HighlightSection from "./Content/ReusableComponents/HighlightSection.vue";
import ImpactSection from "./Content/ImpactSection.vue";
import Focus from "./Content/Focus.vue";
import Growth from "./Content/Growth.vue";
import StepsSection from "./Content/StepsSection.vue";
import WinForAll from "./Content/WinForAll.vue";
import Strategy from "./Content/Strategy.vue";
// import WhyWecobi from "./Content/WhyWecobi.vue";
import StayAhead from "./Content/StayAhead.vue";
import JoinUs from "./Content/JoinUs.vue";

export default {
  name: "SustainabilityContent",
  components: {
    SustainabilityCommitment,
    Mission,
    OurMission,
    Difference,
    HighlightSection,
    ImpactSection,
    Focus,
    Growth,
    StepsSection,
    WinForAll,
    Strategy,
    // WhyWecobi,
    StayAhead,
    JoinUs,
  },
};
</script>

<style scoped>
.content-body {
  padding: 29px 34px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media (max-width: 744px) {
  .content-body {
    padding: 21px 17px;
    gap: 16px;
  }
}
</style>
